import { flags, useFeatureFlags } from 'lib/feature-flags'
import {
  buildCoachFastBookOverlayPath,
  COACH_BOOK_STUDENT_PATH,
  COACH_SCHEDULE_PATH,
  stripCoachFastBookOverlayParams,
} from './coach-book-student'

export const useCoachFastBookStudentEnabled = () => {
  const [isEnabled] = useFeatureFlags([flags.FLAG_FEAT_COACH_FAST_BOOK_STUDENT])
  return Boolean(isEnabled)
}

export const useCoachBookStudentNavigation = () => {
  const isCoachFastBookEnabled = useCoachFastBookStudentEnabled()

  const navigateToBookStudent = (history, params = {}) => {
    if (isCoachFastBookEnabled) {
      const { pathname, search } = history.location
      const overlayPathname =
        pathname === COACH_BOOK_STUDENT_PATH ||
        pathname.endsWith('/book-student')
          ? COACH_SCHEDULE_PATH
          : pathname

      const cleanedSearch = stripCoachFastBookOverlayParams(search)
      history.push(
        buildCoachFastBookOverlayPath(
          overlayPathname,
          params,
          cleanedSearch ? `?${cleanedSearch}` : '',
        ),
      )
      return true
    }
    return false
  }

  return {
    isCoachFastBookEnabled,
    coachBookStudentPath: COACH_BOOK_STUDENT_PATH,
    navigateToBookStudent,
  }
}
